<template>
  <div class="bg-white shadow-md p-12 rounded-s xl:col-span-5 md:col-span-6">
    <h6 class="text-base/[1.6] font-semibold text-gray-600 mb-0 mt-4">
      Giriş Yap
    </h6>
    <p class="text-gray-500 text-sm/[1.6] mt-1 mb-6">
      Hesabınıza giriş yaparak devam edin.
    </p>
    <form @submit.prevent="handleSignIn">
      <div class="mb-4">
        <label for="email" class="block text-sm font-medium mb-1 text-gray-600">
          Email <small>*</small>
        </label>
        <input
          type="email"
          id="email"
          class="py-2 px-4 leading-6 block w-full border-gray-300 rounded text-sm focus:border-gray-300 focus:ring-0"
          placeholder="adiniz@sirketiniz.com"
          v-model="email"
        />
      </div>

      <div class="mb-4">
        <label
          for="password"
          class="block text-sm font-medium mb-1 text-gray-600"
        >
          Şifreniz <small>*</small>
        </label>
        <input
          type="password"
          id="password"
          name="password"
          class="py-2 px-4 leading-6 block w-full border-gray-300 rounded text-sm focus:border-gray-300 focus:ring-0"
          placeholder="Büyük harf, küçük harf, rakam ve özel karakter içermelidir"
          v-model="password"
        />
      </div>

      <div class="mb-0 text-center">
        <button
          class="w-full bg-primary text-white font-medium leading-6 text-center align-middle select-none py-2 px-4 text-base rounded-md transition-all hover:shadow-lg hover:shadow-primary/30"
          type="submit"
        >
          Giriş Yap
        </button>
      </div>
    </form>

    <div class="mt-6 text-center">
      <router-link
        :to="{ name: 'signup' }"
        class="text-primary text-sm font-medium hover:underline"
        >Hesabınız yok mu? Kayıt olun</router-link
      >
    </div>
    <div class="mt-6 text-center">
      <router-link
        :to="{ name: 'password-reset' }"
        class="text-primary text-sm font-medium hover:underline"
        >Şifrenizi mi unuttunuz?</router-link
      >
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { signIn } from "@/services/authServices";
import { useAuthStore } from "@/stores/authStore";
import { useRouter } from "vue-router";
import { Toast } from "@/services/toastService";

const email = ref("");
const password = ref("");
const authStore = useAuthStore();
const router = useRouter();

const onSuccessfulSignIn = () => {
  try {
    router.push({ name: "dashboard" });
  } catch (e) {
    console.error(e);
  }
};

const handleSignIn = async () => {
  try {
    const response = await signIn({
      email: email.value,
      password: password.value,
    });

    if (response.Success) {
      authStore.setUser(response.Payload.User);
      authStore.setToken(response.Payload.Token);
      authStore.setRefreshToken(response.Payload.RefreshToken);

      Toast(
        "Başarılı",
        "Giriş başarılı. Yönlendiriliyorsunuz...",
        "success",
        onSuccessfulSignIn,
        onSuccessfulSignIn,
        false
      );
    } else {
      Toast("Hata", response.Message, "error");
    }
  } catch (error) {
    Toast("Hata", "Bir hata oluştu. Lütfen tekrar deneyin.", "error");
  }
};
</script>
